module.exports = __webpack_public_path__ + "img/login-bg.8de48937.png";